import React from "react";
import { Link } from "react-router-dom";

const HeaderName = ({ selectedHeader, setSelectedHeader, headerName, to }) => {
    if (to.startsWith("https://helios.win"))
        return (
            <li>
                <a href={to}>{headerName}</a>
            </li>
        );
    return (
        <li className={selectedHeader === headerName ? "active" : ""}>
            <Link to={to} onClick={() => setSelectedHeader(headerName)}>
                {headerName}
            </Link>
        </li>
    );
};

export default HeaderName;
